/* eslint-disable */
import React, { Component, Fragment } from 'react';
import { nike } from '@nike/nike-design-tokens';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import orderDetailsProductColumns from './orderDetailsProductColumns';
import orderDetailsForecastProductColumns from './orderDetailsForecastProductColumns';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import Currency from '~COMPONENTS/Currency';
import Collapsible from '~COMPONENTS/Collapsible';
import Icon from '~COMPONENTS/icon/Icon';
import Table from '~COMPONENTS/table/Table';
import ProductGenderDivision from '~COMPONENTS/pdp/ProductGenderDivision';
import SpacerDot from '~COMPONENTS/SpacerDot';
import GlobalToolTip from '~COMPONENTS/tooltips/GlobalToolTip';

import { ProductImage } from '../../components/aurora';
import { productTypes } from '../../types/products';

import { formatColorString } from '../../util/formatColorString';
import { createProductName } from '../../util/createProductName';

const totalsStyle = { display: 'flex', alignItems: 'center' };
const toolTipDivStyle = { marginTop: '10px' };
const toolTipTitleStyle = { fontWeight: 'bolder' };

class OrderDetailsProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: {
        requested: 0,
        confirmed: 0,
        shipped: 0,
        cancelled: 0,
        referenced: 0,
        reserved: 0
      },
      tableSizes: []
    };
  }

  componentDidMount() {
    this.setStats();
    this.setSizeNumbers();
  }

  setStats = () => {
    const {
      product: { sizes }
    } = this.props;

    this.setState({
      stats: {
        requested: this.sum(sizes, 'totalRequestedQty'),
        confirmed: this.sum(sizes, 'totalConfirmedQty'),
        shipped: this.sum(sizes, 'totalShippedQty'),
        cancelled: this.sum(sizes, 'totalCancelledQty'),
        referenced: this.sum(sizes, 'totalOpenReferenceQty'),
        reserved: this.sum(sizes, 'totalReservedQty')
      }
    });
  };

  setSizeNumbers = () => {
    const {
      product: { sizes }
    } = this.props;

    for (let i = 0, l = sizes.length; i < l; i++) {
      Object.keys(sizes[i]).forEach(key => {
        if (sizes[i][key] === null) sizes[i][key] = 0;
      });
    }
    this.setState({ tableSizes: sizes });
  };

  createToolTipContent = () => {
    const { isForecast } = this.props;
    return (
      <div>
        <div>
          <text>
            <span
              className='orderDetails__main__name headline-5 u-bold'
              data-desc='orderDetails__requested'
              style={toolTipTitleStyle}
            >
              {new TranslatedCopy({ id: 'global.requested' }).toString()}
            </span>
            <span>{`: ${new TranslatedCopy({ id: 'orderstatus.details.requested' }).toString()}`}</span>
          </text>
        </div>

        <div style={toolTipDivStyle}>
          <text>
            <span
              className='orderDetails__main__name headline-5 u-bold'
              data-desc='orderDetails__requested'
              style={toolTipTitleStyle}
            >
              {new TranslatedCopy({ id: 'global.confirmed' }).toString()}
            </span>
            <span>{`: ${new TranslatedCopy({ id: 'orderstatus.details.confirmed' }).toString()}`}</span>
          </text>
        </div>
        {isForecast && (
          <>
            <div style={toolTipDivStyle}>
              <text>
                <span
                  className='orderDetails__main__name headline-5 u-bold'
                  data-desc='orderDetails__requested'
                  style={toolTipTitleStyle}
                >
                  {new TranslatedCopy({ id: 'global.reference' }).toString()}
                </span>
                <span>{`: ${new TranslatedCopy({ id: 'orderstatus.details.referenced' }).toString()}`}</span>
              </text>
            </div>
            <div style={toolTipDivStyle}>
              <text>
                <span
                  className='orderDetails__main__name headline-5 u-bold'
                  data-desc='orderDetails__requested'
                  style={toolTipTitleStyle}
                >
                  {new TranslatedCopy({ id: 'global.reserved' }).toString()}
                </span>
                <span>{`: ${new TranslatedCopy({ id: 'orderstatus.details.reserved' }).toString()}`}</span>
              </text>
            </div>
          </>
        )}
        <div style={toolTipDivStyle}>
          <text>
            <span
              className='orderDetails__main__name headline-5 u-bold'
              data-desc='orderDetails__requested'
              style={toolTipTitleStyle}
            >
              {new TranslatedCopy({ id: 'global.cancelled' }).toString()}
            </span>
            <span>{`: ${new TranslatedCopy({ id: 'orderstatus.details.cancelled' }).toString()}`}</span>
          </text>
        </div>
      </div>
    );
  };

  sum = (array, key) => array && array.reduce((sum, object) => sum + object[key], 0);

  render() {
    const {
      product,
      product: {
        productCode,
        division,
        totalNet,
        colorName,
        styleGenderAge,
        copy,
        returnable,
        retailAmount,
        netAmount,
        sizes,
        totalRetail
      },
      expandAll,
      currencyCode,
      isForecast,
      isGreaterChinaSalesOrg
    } = this.props;
    const {
      stats,
      stats: { requested, confirmed, shipped, cancelled, referenced, reserved },
      tableSizes
    } = this.state;
    const quantity = sizes.reduce((sum, { totalRequestedQty }) => sum + totalRequestedQty, 0);
    const name = copy ? copy.name : '';
    return (
      <>
        <div className='orderDetailsProduct bg-white p4-sm p8-md'>
          <div className='orderDetails__main row start'>
            <div className='orderDetails__image mb5-sm mb0-md d-sm-ib'>
              <ProductImage alt={productCode} productCode={productCode} />
            </div>
            <div className='d-sm-b u-full-width ml5-md'>
              <div className='orderDetails__main__name headline-4 u-bold' data-desc={`orderDetails__name_${name}`}>
                {createProductName(product)}
              </div>
              {!returnable && (
                <div className='d-sm-b d-lg-h'>
                  <div
                    className={classnames(
                      'd-h-lg body-4 lh12-sm prl0-md pt2-sm pb2-sm',
                      'flex-container align-center row text-color-secondary'
                    )}
                  >
                    <Icon
                      name='non-returnable'
                      className='pl0-sm mr2-sm'
                      alt={new TranslatedCopy({ id: 'global.nonReturnable' }).toString()}
                    />
                    <TranslatedCopy className='cart__non_returnable_text' id='global.product.nonReturnable' />
                  </div>
                </div>
              )}
              <div
                className='orderDetails__product_copy text-color-secondary body-4 pt2-sm'
                data-desc={`orderDetails_info_${name}`}
              >
                <div data-desc='orderDetails__division'>
                  <ProductGenderDivision gender={styleGenderAge} division={division} />
                </div>
                <div data-desc='orderDetails__style'>
                  <TranslatedCopy id='global.product.style' />
                  {': '}
                  <span data-desc='orderDetails__style_value'>{productCode}</span>
                </div>
                <div data-desc='orderDetails__color'>
                  <TranslatedCopy id='global.product.color' />
                  {': '}
                  <span data-desc='orderDetails__color_value'>{formatColorString(colorName)}</span>
                </div>
                <div data-desc='orderDetails__price'>
                  <span data-desc='orderDetails__price_amount'>
                    {!isGreaterChinaSalesOrg && (
                      <>
                        <TranslatedCopy id='global.product.retail' />
                        &nbsp;
                        <Currency value={retailAmount} type={currencyCode} />
                        <SpacerDot />
                      </>
                    )}
                    <TranslatedCopy id='global.product.wholesale.net' />
                    &nbsp;
                    <Currency value={netAmount} type={currencyCode} />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='orderDetails__totals row'>
            <div>
              <div className='headline-5 pb1-sm'>
                <TranslatedCopy id='orderreturns.totalQuantity' />
                {': '}
                {quantity}
              </div>
              <div className='headline-5 pb1-sm'>
                <TranslatedCopy id='global.total' />
                {': '}
                <Currency value={totalNet} type={currencyCode} />
              </div>
              {!returnable && (
                <div className='d-sm-h d-lg-b'>
                  <div className='body-4 flex-container align-center row prl0-md pb4-sm text-color-secondary'>
                    <Icon
                      name='non-returnable'
                      className='pl0-sm mr2-sm'
                      alt={new TranslatedCopy({ id: 'global.nonReturnable' }).toString()}
                    />
                    <TranslatedCopy className='cart__non_returnable_text' id='global.product.nonReturnable' />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Collapsible
          id={productCode}
          trigger={<TranslatedCopy id='orderstatus.orderDetails.size.quantity' />}
          secondaryTrigger={
            <div className='body-4 mt-4-sm mt0-md' style={totalsStyle}>
              <span>
                {`${requested} `}
                <TranslatedCopy id='global.requested' />
                <SpacerDot />
              </span>
              <span>
                {`${confirmed} `}
                <TranslatedCopy id='global.confirmed' />
                <SpacerDot />
              </span>
              {!isForecast && (
                <span>
                  {`${shipped} `}
                  <TranslatedCopy id='global.shipped' />
                  <SpacerDot />
                </span>
              )}
              {isForecast && (
                <>
                  <span>
                    {`${referenced} `}
                    <TranslatedCopy id='global.reference' />
                    <SpacerDot />
                  </span>
                  <span>
                    {`${reserved} `}
                    <TranslatedCopy id='global.reserved' />
                    <SpacerDot />
                  </span>
                </>
              )}
              <span>
                <span
                  className={cancelled > 0 ? 'u-bold' : ''}
                  style={cancelled > 0 ? { color: nike.podiumCdsColorRed500 } : {}}
                >
                  {`${cancelled} `}
                  <TranslatedCopy id='global.cancelled' />
                </span>
                <SpacerDot />
              </span>
              <span>
                <GlobalToolTip className='min-content' content={this.createToolTipContent()} />
              </span>
            </div>
          }
          classParentString='filter'
          extraClassName={`mb2-sm pl8-md ${division === 'FTWR' ? 'ftwr-sizing-container' : ''}`}
          open={expandAll}
        >
          <Table
            overrideClass='details__product_table'
            data={tableSizes}
            columns={!isForecast ? orderDetailsProductColumns : orderDetailsForecastProductColumns}
            id={productCode}
            headerProps={stats}
          />
        </Collapsible>
      </>
    );
  }
}

OrderDetailsProduct.propTypes = {
  product: productTypes,
  expandAll: PropTypes.bool.isRequired,
  currencyCode: PropTypes.string.isRequired,
  isForecast: PropTypes.bool.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired
};

OrderDetailsProduct.defaultProps = {
  product: {
    productCode: '',
    division: '',
    totalNet: 0,
    colorName: '',
    styleGenderAge: '',
    copy: {
      name: ''
    },
    returnable: false,
    retailAmount: 0,
    netAmount: 0,
    sizes: null
  }
};

export default OrderDetailsProduct;
